// extracted by mini-css-extract-plugin
export default {"list":"List_list__dOR09","list-wrp":"List_list-wrp__ZZZcO","title":"List_title__Vgtrr","managment":"List_managment__uFoTT","managment-btn":"List_managment-btn__gJASk"};